import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=22bdaec4&scoped=true&"
var script = {}
import style0 from "./AdminCard.vue?vue&type=style&index=0&id=22bdaec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdaec4",
  null
  
)

export default component.exports